import React, { useState } from "react";
import "./chart.css";

function ChartImage1() {
  const [form, setForm] = useState({
    name: "",
    dateofbirth: "28/08/2024",
    timeofbirth: "12:22",
    city: "",
    latitude: "",
    longitude: "",
    style: "north",
    lang: "en",
    colored_planets: true,
    color: "%23657798",
  });

  const [svgData, setSvgData] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [zoom, setZoom] = useState(1); // Zoom state

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    if (name === "city") fetchCoordinates(value);
  };

  const fetchCoordinates = async (city) => {
    if (!city) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(city)}`
      );
      const data = await res.json();
      if (data && data[0]) {
        setForm((prev) => ({
          ...prev,
          latitude: data[0].lat,
          longitude: data[0].lon,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch coordinates:", err);
    }
  };

  const fetchChart = async () => {
    setError("");
    setSvgData("");

    const requiredFields = ["dateofbirth", "timeofbirth", "latitude", "longitude"];
    for (let field of requiredFields) {
      if (!form[field]) {
        setError(`Please fill the ${field} field.`);
        return;
      }
    }

    setLoading(true);
    try {
      let apiUrl = `https://api.jyotishamastroapi.com/api/chart_image/d1?date=${form.dateofbirth}&time=${form.timeofbirth}&latitude=${form.latitude}&longitude=${form.longitude}&tz=5.5&style=${form.style}&lang=${form.lang}`;
      if (form.colored_planets) {
        apiUrl += `&colored_planets=true&color=${form.color}`;
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);
      const data = await response.text();

      const cleanSVG = data
        .replace(/\\n/g, "")
        .replace(/\\r/g, "")
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'")
        .replace(/\\\\/g, "\\")
        .trim();

      setSvgData(cleanSVG);
      setZoom(1); // Reset zoom when chart reloads
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const renderInputs = () => {
    const fields = [
      { name: "name", label: "Full Name", type: "text" },
      { name: "dateofbirth", label: "Date of Birth", type: "date" },
      { name: "timeofbirth", label: "Time of Birth", type: "time" },
      { name: "city", label: "City / Place", type: "text" },
    ];

    return fields.map((field) => (
      <div className="D1-form-group" key={field.name}>
        <label>{field.label}</label>
        <input
          type={field.type}
          name={field.name}
          value={form[field.name]}
          onChange={handleInputChange}
          required
        />
      </div>
    ));
  };

  // ✅ Zoom with Limits (0.5x min, 1.8x max)
  const handleZoomIn = () => setZoom((z) => Math.min(1.8, parseFloat((z + 0.1).toFixed(2))));
  const handleZoomOut = () => setZoom((z) => Math.max(0.5, parseFloat((z - 0.1).toFixed(2))));
  const handleResetZoom = () => setZoom(1);

  return (
    <div className="container">
      <h2 className="chart-title">🪶 Generate D1 Birth Chart</h2>

      <div className="ra-d1-chart">
        <div className="d1-form-container">
          {renderInputs()}

          <label>Style</label>
          <select name="style" value={form.style} onChange={handleInputChange}>
            <option value="north">North</option>
            <option value="south">South</option>
            <option value="east">East</option>
          </select>

          <label>Language</label>
          <select name="lang" value={form.lang} onChange={handleInputChange}>
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="ta">Tamil</option>
            <option value="te">Telugu</option>
            <option value="ka">Kannada</option>
            <option value="ml">Malayalam</option>
            <option value="be">Bengali</option>
            <option value="gr">Gujarati</option>
            <option value="mr">Marathi</option>
          </select>

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={form.colored_planets}
              name="colored_planets"
              onChange={(e) =>
                setForm({ ...form, colored_planets: e.target.checked })
              }
            />
            Colored Planets
          </label>

          {form.colored_planets && (
            <input
              type="text"
              placeholder="%23 + Color Code"
              name="color"
              value={form.color}
              onChange={handleInputChange}
            />
          )}

          <button className="fetch-btn" onClick={fetchChart}>
            {loading ? "Loading..." : "Generate Chart"}
          </button>
        </div>

        <div className="main-svg-chart-part">
          {error && <p className="error-message">{error}</p>}

          {svgData && (
            <>
              <div className="zoom-controls">
                <button onClick={handleZoomOut}>➖</button>
                <span>{Math.round(zoom * 100)}%</span>
                <button onClick={handleZoomIn}>➕</button>
                <button onClick={handleResetZoom}>🔄</button>
              </div>

              <div className="chart-svg-wrapper">
                <div
                  className="chart-svg zoomable"
                  style={{
                    transform: `scale(${zoom})`,
                    transformOrigin: "center center",
                  }}
                  dangerouslySetInnerHTML={{ __html: svgData }}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChartImage1;
